import useLocalStore from '../../../hooks/useLocalStore.js';
import FJVoiceCloningItem from '../view/FJVoiceCloningItem.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FJActionCommon from '../../../redux/action/FJActionCommon.js';
import { setSliceSelectListAction } from '../../../redux/slices/FJSliceCommon.js';
import FJDropDownManager from '../../../common/js/FJDropDownManager.js';
import FJTextToSpeechData from '../../../config/dataConfig/FJTextToSpeechData.js';
import FJActionVoiceCloning from '../../../redux/action/FJActionVoiceCloning.js';
import FJConstant from '../../../constants/FJConstant.js';
import FJAudioPlayManager from '../../../store/FJAudioPlayManager.js';
import FJActionTextToSpeech from '../../../redux/action/FJActionTextToSpeech.js';
import PropTypes from 'prop-types';

const FJVoiceCloningItemContainer = props => {
    useLocalStore();
    const dispatch = useDispatch();
    const { info } = props;
    const { audioUrl, name, avatar, id, lang } = info;
    const isMultipleMode = useSelector(state => state.common.isMultipleMode);
    const selectList = useSelector(state => state.common.selectList);
    const selected = !!selectList?.find(i => i === id);
    const showLang = FJTextToSpeechData.LANGUAGE_LIST.find(item => item.value === lang)?.label || 'English';
    const _enterMultiple = () => {
        FJDropDownManager.hideAll();
        dispatch(FJActionCommon.setIsMultipleModeAction(true));
        dispatch(setSliceSelectListAction([id]));
    };

    const _onSelected = (id, bool) => {
        if (bool) {
            dispatch(setSliceSelectListAction([...selectList, id]));
        } else {
            dispatch(setSliceSelectListAction(selectList.filter(i => i !== id)));
        }
    };

    const _deleteVoice = () => {
        FJAudioPlayManager.pauseAll();
        FJDropDownManager.hideAll();
        dispatch(FJActionCommon.multiDeleteAction([id], undefined, { type: FJConstant.CLONE_VOICE }));
    };

    const _editVoice = () => {
        FJDropDownManager.hideAll();
        dispatch(FJActionVoiceCloning.showVoiceCloneEditAction(info));
    };

    const _onUse = () => {
        dispatch(FJActionTextToSpeech.useVoiceItemAction(info, { isAdd: true, fromType: FJConstant.CLONE_BY_SELF }));
    };

    return (
        <FJVoiceCloningItem
            audioUrl={audioUrl}
            name={name}
            avatar={avatar}
            id={id}
            isSelected={selected}
            isMultipleMode={isMultipleMode}
            enterMultiple={_enterMultiple}
            deleteVoice={_deleteVoice}
            editVoice={_editVoice}
            onSelected={_onSelected}
            showLang={showLang}
            onUse={_onUse}
        />
    );
};

FJVoiceCloningItemContainer.propTypes = {
    info: PropTypes.object,
};

export default FJVoiceCloningItemContainer;
